module.exports = __webpack_public_path__ + "static/hero-desktop-lrg-1dc09fd091e41b87c0d86059b99cc33e.png";